import React from 'react'
import PropTypes from 'prop-types'

const Main = ({ children }) => (
  <main className="bg-gray-50 flex flex-1 overflow-y-auto md:overflow-y-auto">
    <div className="flex-1 mt-auto mb-auto w-full py-8 md:py-12">
      {children}
    </div>
  </main>
)

Main.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Main
